/* eslint-disable */
'use strict';
var _maxExpireDate = new Date(9999, 12, 12);
var _defaultExpire = _maxExpireDate;
var jsonTransformer = {
  str: function(data) {
    return JSON.stringify(data);
  },
  json: function(data) {
    try {
      return data && JSON.parse(data);
    } catch (error) {
      return null;
    }
  }
};

/* object extend */
function _extend(obj, props) {
  for (var key in props) obj[key] = props[key];
  return obj;
}

function _getSystemStorage(storage) {
  if (typeof storage === 'string' && window[storage] instanceof Storage) {
    return window[storage];
  }
  return {};
}

function _getExpiresDate(expires, now) {
  now = now || new Date();
  if (typeof expires === 'number') {
    expires =
      expires === Infinity
        ? _maxExpireDate
        : new Date(now.getTime() + expires * 1000);
  } else if (typeof expires === 'string') {
    expires = new Date(expires);
  }
  return expires;
}

function CacheItem(val, exp) {
  var expires = _getExpiresDate(exp || _defaultExpire);
  this.e = expires.getTime();
  this.data = val;
}

function _checkCacheItemKeyAsString(key) {
  if (typeof key !== 'string') {
    console.warn(key + 'key must be a string');
    key = String(key);
  }
  return key;
}

function _checkCacheItemIfEffective(cacheItem) {
  return Date.now() < cacheItem.e;
}

function _isValidDate(date) {
  return (
    Object.prototype.toString.call(date) === '[object Date]' &&
    !isNaN(date.getTime())
  );
}

function _isCacheItem(item) {
  if (typeof item !== 'object') {
    return false;
  }
  if (item) {
    if ('e' in item && 'data' in item) {
      return true;
    }
  }
  return false;
}

function zxy(options) {
  var defaults = { storage: 'localStorage', exp: Infinity };
  var opt = _extend(defaults, options);
  var expires = opt.exp;
  if (expires && typeof expires !== 'number' && !_isValidDate(expires)) {
    throw new Error('exp: 参数必须是能被日期构造器正确实例化');
  } else {
    _defaultExpire = expires;
  }
  this.storage = _getSystemStorage(opt.storage);
}

zxy.prototype = {
  set: function(key, val, options) {
    var value, cacheItem;
    key = _checkCacheItemKeyAsString(key);
    if (typeof options === 'number') options = { exp: options };
    if (val === undefined) return this.delete(key);
    value = val;
    cacheItem = new CacheItem(value, options.exp);
    try {
      this.storage.setItem(key, jsonTransformer.str(cacheItem));
    } catch (e) {
      this.storage[key] = cacheItem;
    }
  },
  get: function(key) {
    var cacheItem = null;
    key = _checkCacheItemKeyAsString(key);
    try {
      cacheItem = jsonTransformer.json(this.storage.getItem(key));
    } catch (e) {
      cacheItem = this.storage[key];
    }
    if (_isCacheItem(cacheItem)) {
      if (_checkCacheItemIfEffective(cacheItem)) {
        return cacheItem.data;
      } else {
        this.delete(key);
      }
    }
    return null;
  },
  delete: function(key) {
    try {
      this.storage.removeItem(key);
    } catch (e) {
      delete this.storage[key];
    }
  },
  deleteAllExpires: function() {
    var keys = Object.keys(this.storage),
      deleteKeys = [],
      key,
      _this = this;
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var cacheItem = null;
      try {
        cacheItem = jsonTransformer.json(this.storage.getItem(key));
      } catch (e) {
        cacheItem = this.storage[key];
      }
      if (cacheItem !== null && cacheItem.e !== undefined) {
        var timeNow = new Date().getTime();
        if (timeNow >= cacheItem.e) {
          deleteKeys.push(key);
        }
      }
    }
    deleteKeys.forEach(function(key) {
      _this.delete(key);
    });
    return deleteKeys;
  },
  clear: function() {
    this.storage = {};
  },
  replace: function(key, val, options) {
    var cacheItem = null;
    key = _checkCacheItemKeyAsString(key);
    try {
      cacheItem = this.storage.getItem(key);
    } catch (e) {
      cacheItem = this.storage[key];
    }
    if (_isCacheItem(cacheItem)) {
      if (_checkCacheItemIfEffective(cacheItem)) {
        this.set(key, val, options);
        return true;
      } else {
        this.delete(key);
      }
    }
    return false;
  },
  cacheKey: function(opts) {
    var url = opts.url.split('?')[0];
    var type = opts.type;
    var data = opts.data && JSON.stringify(opts.data);
    var str = type + url;
    if (data) {
      str += data;
    }
    return str;
  },
  isFilter: function(key, blacklist) {
    blacklist = blacklist || [];
    return (
      blacklist.filter(function(el) {
        return key.indexOf(el) > -1;
      }).length > 0
    );
  },
  length: function() {
    var count = 0;
    for (var key in this.storage) {
      if (this.hasOwnProperty(key)) count++;
    }
    return count;
  }
};

export {zxy}